/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as AuthenticatedRouteImport } from './routes/_authenticated'
import { Route as IndexRouteImport } from './routes/index'
import { Route as UsersRegistrationRouteImport } from './routes/users/registration'
import { Route as UsersPasswordResetRouteImport } from './routes/users/password-reset'
import { Route as UsersEmailVerificationRouteImport } from './routes/users/email-verification'
import { Route as AuthLoginRouteImport } from './routes/auth.login'
import { Route as AuthenticatedActiveSubscriptionRouteImport } from './routes/_authenticated/_active-subscription'
import { Route as UsersSubscriptionSuccessRouteImport } from './routes/users/subscription/success'
import { Route as UsersSubscriptionPlansRouteImport } from './routes/users/subscription/plans'
import { Route as UsersSubscriptionFailureRouteImport } from './routes/users/subscription/failure'
import { Route as AuthenticatedUsersOnboardingIndexRouteImport } from './routes/_authenticated/users/onboarding/index'
import { Route as AuthenticatedUsersOnboardingThirdStepRouteImport } from './routes/_authenticated/users/onboarding/third-step'
import { Route as AuthenticatedUsersOnboardingSixthStepRouteImport } from './routes/_authenticated/users/onboarding/sixth-step'
import { Route as AuthenticatedUsersOnboardingSecondStepRouteImport } from './routes/_authenticated/users/onboarding/second-step'
import { Route as AuthenticatedUsersOnboardingResumeRouteImport } from './routes/_authenticated/users/onboarding/resume'
import { Route as AuthenticatedUsersOnboardingFourthStepRouteImport } from './routes/_authenticated/users/onboarding/fourth-step'
import { Route as AuthenticatedUsersOnboardingFirstStepRouteImport } from './routes/_authenticated/users/onboarding/first-step'
import { Route as AuthenticatedUsersOnboardingFifthStepRouteImport } from './routes/_authenticated/users/onboarding/fifth-step'
import { Route as AuthenticatedActiveSubscriptionUsersTermsAndConditionsRouteImport } from './routes/_authenticated/_active-subscription/users/terms-and-conditions'
import { Route as AuthenticatedActiveSubscriptionUsersSettingsRouteImport } from './routes/_authenticated/_active-subscription/users/settings'
import { Route as AuthenticatedActiveSubscriptionUsersProfileRouteImport } from './routes/_authenticated/_active-subscription/users/profile'
import { Route as AuthenticatedActiveSubscriptionUsersMetricsRouteImport } from './routes/_authenticated/_active-subscription/users/metrics'
import { Route as AuthenticatedActiveSubscriptionUsersHomeRouteImport } from './routes/_authenticated/_active-subscription/users/home'
import { Route as AuthenticatedActiveSubscriptionUsersHelpRouteImport } from './routes/_authenticated/_active-subscription/users/help'
import { Route as AuthenticatedActiveSubscriptionUsersDiaryRouteImport } from './routes/_authenticated/_active-subscription/users/diary'

const AuthenticatedRoute = AuthenticatedRouteImport.update({
  id: '/_authenticated',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const UsersRegistrationRoute = UsersRegistrationRouteImport.update({
  id: '/users/registration',
  path: '/users/registration',
  getParentRoute: () => rootRouteImport,
} as any)
const UsersPasswordResetRoute = UsersPasswordResetRouteImport.update({
  id: '/users/password-reset',
  path: '/users/password-reset',
  getParentRoute: () => rootRouteImport,
} as any)
const UsersEmailVerificationRoute = UsersEmailVerificationRouteImport.update({
  id: '/users/email-verification',
  path: '/users/email-verification',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthLoginRoute = AuthLoginRouteImport.update({
  id: '/auth/login',
  path: '/auth/login',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedActiveSubscriptionRoute =
  AuthenticatedActiveSubscriptionRouteImport.update({
    id: '/_active-subscription',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const UsersSubscriptionSuccessRoute =
  UsersSubscriptionSuccessRouteImport.update({
    id: '/users/subscription/success',
    path: '/users/subscription/success',
    getParentRoute: () => rootRouteImport,
  } as any)
const UsersSubscriptionPlansRoute = UsersSubscriptionPlansRouteImport.update({
  id: '/users/subscription/plans',
  path: '/users/subscription/plans',
  getParentRoute: () => rootRouteImport,
} as any)
const UsersSubscriptionFailureRoute =
  UsersSubscriptionFailureRouteImport.update({
    id: '/users/subscription/failure',
    path: '/users/subscription/failure',
    getParentRoute: () => rootRouteImport,
  } as any)
const AuthenticatedUsersOnboardingIndexRoute =
  AuthenticatedUsersOnboardingIndexRouteImport.update({
    id: '/users/onboarding/',
    path: '/users/onboarding/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedUsersOnboardingThirdStepRoute =
  AuthenticatedUsersOnboardingThirdStepRouteImport.update({
    id: '/users/onboarding/third-step',
    path: '/users/onboarding/third-step',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedUsersOnboardingSixthStepRoute =
  AuthenticatedUsersOnboardingSixthStepRouteImport.update({
    id: '/users/onboarding/sixth-step',
    path: '/users/onboarding/sixth-step',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedUsersOnboardingSecondStepRoute =
  AuthenticatedUsersOnboardingSecondStepRouteImport.update({
    id: '/users/onboarding/second-step',
    path: '/users/onboarding/second-step',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedUsersOnboardingResumeRoute =
  AuthenticatedUsersOnboardingResumeRouteImport.update({
    id: '/users/onboarding/resume',
    path: '/users/onboarding/resume',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedUsersOnboardingFourthStepRoute =
  AuthenticatedUsersOnboardingFourthStepRouteImport.update({
    id: '/users/onboarding/fourth-step',
    path: '/users/onboarding/fourth-step',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedUsersOnboardingFirstStepRoute =
  AuthenticatedUsersOnboardingFirstStepRouteImport.update({
    id: '/users/onboarding/first-step',
    path: '/users/onboarding/first-step',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedUsersOnboardingFifthStepRoute =
  AuthenticatedUsersOnboardingFifthStepRouteImport.update({
    id: '/users/onboarding/fifth-step',
    path: '/users/onboarding/fifth-step',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedActiveSubscriptionUsersTermsAndConditionsRoute =
  AuthenticatedActiveSubscriptionUsersTermsAndConditionsRouteImport.update({
    id: '/users/terms-and-conditions',
    path: '/users/terms-and-conditions',
    getParentRoute: () => AuthenticatedActiveSubscriptionRoute,
  } as any)
const AuthenticatedActiveSubscriptionUsersSettingsRoute =
  AuthenticatedActiveSubscriptionUsersSettingsRouteImport.update({
    id: '/users/settings',
    path: '/users/settings',
    getParentRoute: () => AuthenticatedActiveSubscriptionRoute,
  } as any)
const AuthenticatedActiveSubscriptionUsersProfileRoute =
  AuthenticatedActiveSubscriptionUsersProfileRouteImport.update({
    id: '/users/profile',
    path: '/users/profile',
    getParentRoute: () => AuthenticatedActiveSubscriptionRoute,
  } as any)
const AuthenticatedActiveSubscriptionUsersMetricsRoute =
  AuthenticatedActiveSubscriptionUsersMetricsRouteImport.update({
    id: '/users/metrics',
    path: '/users/metrics',
    getParentRoute: () => AuthenticatedActiveSubscriptionRoute,
  } as any)
const AuthenticatedActiveSubscriptionUsersHomeRoute =
  AuthenticatedActiveSubscriptionUsersHomeRouteImport.update({
    id: '/users/home',
    path: '/users/home',
    getParentRoute: () => AuthenticatedActiveSubscriptionRoute,
  } as any)
const AuthenticatedActiveSubscriptionUsersHelpRoute =
  AuthenticatedActiveSubscriptionUsersHelpRouteImport.update({
    id: '/users/help',
    path: '/users/help',
    getParentRoute: () => AuthenticatedActiveSubscriptionRoute,
  } as any)
const AuthenticatedActiveSubscriptionUsersDiaryRoute =
  AuthenticatedActiveSubscriptionUsersDiaryRouteImport.update({
    id: '/users/diary',
    path: '/users/diary',
    getParentRoute: () => AuthenticatedActiveSubscriptionRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/auth/login': typeof AuthLoginRoute
  '/users/email-verification': typeof UsersEmailVerificationRoute
  '/users/password-reset': typeof UsersPasswordResetRoute
  '/users/registration': typeof UsersRegistrationRoute
  '/users/subscription/failure': typeof UsersSubscriptionFailureRoute
  '/users/subscription/plans': typeof UsersSubscriptionPlansRoute
  '/users/subscription/success': typeof UsersSubscriptionSuccessRoute
  '/users/diary': typeof AuthenticatedActiveSubscriptionUsersDiaryRoute
  '/users/help': typeof AuthenticatedActiveSubscriptionUsersHelpRoute
  '/users/home': typeof AuthenticatedActiveSubscriptionUsersHomeRoute
  '/users/metrics': typeof AuthenticatedActiveSubscriptionUsersMetricsRoute
  '/users/profile': typeof AuthenticatedActiveSubscriptionUsersProfileRoute
  '/users/settings': typeof AuthenticatedActiveSubscriptionUsersSettingsRoute
  '/users/terms-and-conditions': typeof AuthenticatedActiveSubscriptionUsersTermsAndConditionsRoute
  '/users/onboarding/fifth-step': typeof AuthenticatedUsersOnboardingFifthStepRoute
  '/users/onboarding/first-step': typeof AuthenticatedUsersOnboardingFirstStepRoute
  '/users/onboarding/fourth-step': typeof AuthenticatedUsersOnboardingFourthStepRoute
  '/users/onboarding/resume': typeof AuthenticatedUsersOnboardingResumeRoute
  '/users/onboarding/second-step': typeof AuthenticatedUsersOnboardingSecondStepRoute
  '/users/onboarding/sixth-step': typeof AuthenticatedUsersOnboardingSixthStepRoute
  '/users/onboarding/third-step': typeof AuthenticatedUsersOnboardingThirdStepRoute
  '/users/onboarding': typeof AuthenticatedUsersOnboardingIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/auth/login': typeof AuthLoginRoute
  '/users/email-verification': typeof UsersEmailVerificationRoute
  '/users/password-reset': typeof UsersPasswordResetRoute
  '/users/registration': typeof UsersRegistrationRoute
  '/users/subscription/failure': typeof UsersSubscriptionFailureRoute
  '/users/subscription/plans': typeof UsersSubscriptionPlansRoute
  '/users/subscription/success': typeof UsersSubscriptionSuccessRoute
  '/users/diary': typeof AuthenticatedActiveSubscriptionUsersDiaryRoute
  '/users/help': typeof AuthenticatedActiveSubscriptionUsersHelpRoute
  '/users/home': typeof AuthenticatedActiveSubscriptionUsersHomeRoute
  '/users/metrics': typeof AuthenticatedActiveSubscriptionUsersMetricsRoute
  '/users/profile': typeof AuthenticatedActiveSubscriptionUsersProfileRoute
  '/users/settings': typeof AuthenticatedActiveSubscriptionUsersSettingsRoute
  '/users/terms-and-conditions': typeof AuthenticatedActiveSubscriptionUsersTermsAndConditionsRoute
  '/users/onboarding/fifth-step': typeof AuthenticatedUsersOnboardingFifthStepRoute
  '/users/onboarding/first-step': typeof AuthenticatedUsersOnboardingFirstStepRoute
  '/users/onboarding/fourth-step': typeof AuthenticatedUsersOnboardingFourthStepRoute
  '/users/onboarding/resume': typeof AuthenticatedUsersOnboardingResumeRoute
  '/users/onboarding/second-step': typeof AuthenticatedUsersOnboardingSecondStepRoute
  '/users/onboarding/sixth-step': typeof AuthenticatedUsersOnboardingSixthStepRoute
  '/users/onboarding/third-step': typeof AuthenticatedUsersOnboardingThirdStepRoute
  '/users/onboarding': typeof AuthenticatedUsersOnboardingIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/_authenticated': typeof AuthenticatedRouteWithChildren
  '/_authenticated/_active-subscription': typeof AuthenticatedActiveSubscriptionRouteWithChildren
  '/auth/login': typeof AuthLoginRoute
  '/users/email-verification': typeof UsersEmailVerificationRoute
  '/users/password-reset': typeof UsersPasswordResetRoute
  '/users/registration': typeof UsersRegistrationRoute
  '/users/subscription/failure': typeof UsersSubscriptionFailureRoute
  '/users/subscription/plans': typeof UsersSubscriptionPlansRoute
  '/users/subscription/success': typeof UsersSubscriptionSuccessRoute
  '/_authenticated/_active-subscription/users/diary': typeof AuthenticatedActiveSubscriptionUsersDiaryRoute
  '/_authenticated/_active-subscription/users/help': typeof AuthenticatedActiveSubscriptionUsersHelpRoute
  '/_authenticated/_active-subscription/users/home': typeof AuthenticatedActiveSubscriptionUsersHomeRoute
  '/_authenticated/_active-subscription/users/metrics': typeof AuthenticatedActiveSubscriptionUsersMetricsRoute
  '/_authenticated/_active-subscription/users/profile': typeof AuthenticatedActiveSubscriptionUsersProfileRoute
  '/_authenticated/_active-subscription/users/settings': typeof AuthenticatedActiveSubscriptionUsersSettingsRoute
  '/_authenticated/_active-subscription/users/terms-and-conditions': typeof AuthenticatedActiveSubscriptionUsersTermsAndConditionsRoute
  '/_authenticated/users/onboarding/fifth-step': typeof AuthenticatedUsersOnboardingFifthStepRoute
  '/_authenticated/users/onboarding/first-step': typeof AuthenticatedUsersOnboardingFirstStepRoute
  '/_authenticated/users/onboarding/fourth-step': typeof AuthenticatedUsersOnboardingFourthStepRoute
  '/_authenticated/users/onboarding/resume': typeof AuthenticatedUsersOnboardingResumeRoute
  '/_authenticated/users/onboarding/second-step': typeof AuthenticatedUsersOnboardingSecondStepRoute
  '/_authenticated/users/onboarding/sixth-step': typeof AuthenticatedUsersOnboardingSixthStepRoute
  '/_authenticated/users/onboarding/third-step': typeof AuthenticatedUsersOnboardingThirdStepRoute
  '/_authenticated/users/onboarding/': typeof AuthenticatedUsersOnboardingIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/auth/login'
    | '/users/email-verification'
    | '/users/password-reset'
    | '/users/registration'
    | '/users/subscription/failure'
    | '/users/subscription/plans'
    | '/users/subscription/success'
    | '/users/diary'
    | '/users/help'
    | '/users/home'
    | '/users/metrics'
    | '/users/profile'
    | '/users/settings'
    | '/users/terms-and-conditions'
    | '/users/onboarding/fifth-step'
    | '/users/onboarding/first-step'
    | '/users/onboarding/fourth-step'
    | '/users/onboarding/resume'
    | '/users/onboarding/second-step'
    | '/users/onboarding/sixth-step'
    | '/users/onboarding/third-step'
    | '/users/onboarding'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/auth/login'
    | '/users/email-verification'
    | '/users/password-reset'
    | '/users/registration'
    | '/users/subscription/failure'
    | '/users/subscription/plans'
    | '/users/subscription/success'
    | '/users/diary'
    | '/users/help'
    | '/users/home'
    | '/users/metrics'
    | '/users/profile'
    | '/users/settings'
    | '/users/terms-and-conditions'
    | '/users/onboarding/fifth-step'
    | '/users/onboarding/first-step'
    | '/users/onboarding/fourth-step'
    | '/users/onboarding/resume'
    | '/users/onboarding/second-step'
    | '/users/onboarding/sixth-step'
    | '/users/onboarding/third-step'
    | '/users/onboarding'
  id:
    | '__root__'
    | '/'
    | '/_authenticated'
    | '/_authenticated/_active-subscription'
    | '/auth/login'
    | '/users/email-verification'
    | '/users/password-reset'
    | '/users/registration'
    | '/users/subscription/failure'
    | '/users/subscription/plans'
    | '/users/subscription/success'
    | '/_authenticated/_active-subscription/users/diary'
    | '/_authenticated/_active-subscription/users/help'
    | '/_authenticated/_active-subscription/users/home'
    | '/_authenticated/_active-subscription/users/metrics'
    | '/_authenticated/_active-subscription/users/profile'
    | '/_authenticated/_active-subscription/users/settings'
    | '/_authenticated/_active-subscription/users/terms-and-conditions'
    | '/_authenticated/users/onboarding/fifth-step'
    | '/_authenticated/users/onboarding/first-step'
    | '/_authenticated/users/onboarding/fourth-step'
    | '/_authenticated/users/onboarding/resume'
    | '/_authenticated/users/onboarding/second-step'
    | '/_authenticated/users/onboarding/sixth-step'
    | '/_authenticated/users/onboarding/third-step'
    | '/_authenticated/users/onboarding/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AuthenticatedRoute: typeof AuthenticatedRouteWithChildren
  AuthLoginRoute: typeof AuthLoginRoute
  UsersEmailVerificationRoute: typeof UsersEmailVerificationRoute
  UsersPasswordResetRoute: typeof UsersPasswordResetRoute
  UsersRegistrationRoute: typeof UsersRegistrationRoute
  UsersSubscriptionFailureRoute: typeof UsersSubscriptionFailureRoute
  UsersSubscriptionPlansRoute: typeof UsersSubscriptionPlansRoute
  UsersSubscriptionSuccessRoute: typeof UsersSubscriptionSuccessRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_authenticated': {
      id: '/_authenticated'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof AuthenticatedRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/users/registration': {
      id: '/users/registration'
      path: '/users/registration'
      fullPath: '/users/registration'
      preLoaderRoute: typeof UsersRegistrationRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/users/password-reset': {
      id: '/users/password-reset'
      path: '/users/password-reset'
      fullPath: '/users/password-reset'
      preLoaderRoute: typeof UsersPasswordResetRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/users/email-verification': {
      id: '/users/email-verification'
      path: '/users/email-verification'
      fullPath: '/users/email-verification'
      preLoaderRoute: typeof UsersEmailVerificationRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/auth/login': {
      id: '/auth/login'
      path: '/auth/login'
      fullPath: '/auth/login'
      preLoaderRoute: typeof AuthLoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated/_active-subscription': {
      id: '/_authenticated/_active-subscription'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof AuthenticatedActiveSubscriptionRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/users/subscription/success': {
      id: '/users/subscription/success'
      path: '/users/subscription/success'
      fullPath: '/users/subscription/success'
      preLoaderRoute: typeof UsersSubscriptionSuccessRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/users/subscription/plans': {
      id: '/users/subscription/plans'
      path: '/users/subscription/plans'
      fullPath: '/users/subscription/plans'
      preLoaderRoute: typeof UsersSubscriptionPlansRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/users/subscription/failure': {
      id: '/users/subscription/failure'
      path: '/users/subscription/failure'
      fullPath: '/users/subscription/failure'
      preLoaderRoute: typeof UsersSubscriptionFailureRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated/users/onboarding/': {
      id: '/_authenticated/users/onboarding/'
      path: '/users/onboarding'
      fullPath: '/users/onboarding'
      preLoaderRoute: typeof AuthenticatedUsersOnboardingIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/users/onboarding/third-step': {
      id: '/_authenticated/users/onboarding/third-step'
      path: '/users/onboarding/third-step'
      fullPath: '/users/onboarding/third-step'
      preLoaderRoute: typeof AuthenticatedUsersOnboardingThirdStepRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/users/onboarding/sixth-step': {
      id: '/_authenticated/users/onboarding/sixth-step'
      path: '/users/onboarding/sixth-step'
      fullPath: '/users/onboarding/sixth-step'
      preLoaderRoute: typeof AuthenticatedUsersOnboardingSixthStepRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/users/onboarding/second-step': {
      id: '/_authenticated/users/onboarding/second-step'
      path: '/users/onboarding/second-step'
      fullPath: '/users/onboarding/second-step'
      preLoaderRoute: typeof AuthenticatedUsersOnboardingSecondStepRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/users/onboarding/resume': {
      id: '/_authenticated/users/onboarding/resume'
      path: '/users/onboarding/resume'
      fullPath: '/users/onboarding/resume'
      preLoaderRoute: typeof AuthenticatedUsersOnboardingResumeRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/users/onboarding/fourth-step': {
      id: '/_authenticated/users/onboarding/fourth-step'
      path: '/users/onboarding/fourth-step'
      fullPath: '/users/onboarding/fourth-step'
      preLoaderRoute: typeof AuthenticatedUsersOnboardingFourthStepRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/users/onboarding/first-step': {
      id: '/_authenticated/users/onboarding/first-step'
      path: '/users/onboarding/first-step'
      fullPath: '/users/onboarding/first-step'
      preLoaderRoute: typeof AuthenticatedUsersOnboardingFirstStepRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/users/onboarding/fifth-step': {
      id: '/_authenticated/users/onboarding/fifth-step'
      path: '/users/onboarding/fifth-step'
      fullPath: '/users/onboarding/fifth-step'
      preLoaderRoute: typeof AuthenticatedUsersOnboardingFifthStepRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/_active-subscription/users/terms-and-conditions': {
      id: '/_authenticated/_active-subscription/users/terms-and-conditions'
      path: '/users/terms-and-conditions'
      fullPath: '/users/terms-and-conditions'
      preLoaderRoute: typeof AuthenticatedActiveSubscriptionUsersTermsAndConditionsRouteImport
      parentRoute: typeof AuthenticatedActiveSubscriptionRoute
    }
    '/_authenticated/_active-subscription/users/settings': {
      id: '/_authenticated/_active-subscription/users/settings'
      path: '/users/settings'
      fullPath: '/users/settings'
      preLoaderRoute: typeof AuthenticatedActiveSubscriptionUsersSettingsRouteImport
      parentRoute: typeof AuthenticatedActiveSubscriptionRoute
    }
    '/_authenticated/_active-subscription/users/profile': {
      id: '/_authenticated/_active-subscription/users/profile'
      path: '/users/profile'
      fullPath: '/users/profile'
      preLoaderRoute: typeof AuthenticatedActiveSubscriptionUsersProfileRouteImport
      parentRoute: typeof AuthenticatedActiveSubscriptionRoute
    }
    '/_authenticated/_active-subscription/users/metrics': {
      id: '/_authenticated/_active-subscription/users/metrics'
      path: '/users/metrics'
      fullPath: '/users/metrics'
      preLoaderRoute: typeof AuthenticatedActiveSubscriptionUsersMetricsRouteImport
      parentRoute: typeof AuthenticatedActiveSubscriptionRoute
    }
    '/_authenticated/_active-subscription/users/home': {
      id: '/_authenticated/_active-subscription/users/home'
      path: '/users/home'
      fullPath: '/users/home'
      preLoaderRoute: typeof AuthenticatedActiveSubscriptionUsersHomeRouteImport
      parentRoute: typeof AuthenticatedActiveSubscriptionRoute
    }
    '/_authenticated/_active-subscription/users/help': {
      id: '/_authenticated/_active-subscription/users/help'
      path: '/users/help'
      fullPath: '/users/help'
      preLoaderRoute: typeof AuthenticatedActiveSubscriptionUsersHelpRouteImport
      parentRoute: typeof AuthenticatedActiveSubscriptionRoute
    }
    '/_authenticated/_active-subscription/users/diary': {
      id: '/_authenticated/_active-subscription/users/diary'
      path: '/users/diary'
      fullPath: '/users/diary'
      preLoaderRoute: typeof AuthenticatedActiveSubscriptionUsersDiaryRouteImport
      parentRoute: typeof AuthenticatedActiveSubscriptionRoute
    }
  }
}

interface AuthenticatedActiveSubscriptionRouteChildren {
  AuthenticatedActiveSubscriptionUsersDiaryRoute: typeof AuthenticatedActiveSubscriptionUsersDiaryRoute
  AuthenticatedActiveSubscriptionUsersHelpRoute: typeof AuthenticatedActiveSubscriptionUsersHelpRoute
  AuthenticatedActiveSubscriptionUsersHomeRoute: typeof AuthenticatedActiveSubscriptionUsersHomeRoute
  AuthenticatedActiveSubscriptionUsersMetricsRoute: typeof AuthenticatedActiveSubscriptionUsersMetricsRoute
  AuthenticatedActiveSubscriptionUsersProfileRoute: typeof AuthenticatedActiveSubscriptionUsersProfileRoute
  AuthenticatedActiveSubscriptionUsersSettingsRoute: typeof AuthenticatedActiveSubscriptionUsersSettingsRoute
  AuthenticatedActiveSubscriptionUsersTermsAndConditionsRoute: typeof AuthenticatedActiveSubscriptionUsersTermsAndConditionsRoute
}

const AuthenticatedActiveSubscriptionRouteChildren: AuthenticatedActiveSubscriptionRouteChildren =
  {
    AuthenticatedActiveSubscriptionUsersDiaryRoute:
      AuthenticatedActiveSubscriptionUsersDiaryRoute,
    AuthenticatedActiveSubscriptionUsersHelpRoute:
      AuthenticatedActiveSubscriptionUsersHelpRoute,
    AuthenticatedActiveSubscriptionUsersHomeRoute:
      AuthenticatedActiveSubscriptionUsersHomeRoute,
    AuthenticatedActiveSubscriptionUsersMetricsRoute:
      AuthenticatedActiveSubscriptionUsersMetricsRoute,
    AuthenticatedActiveSubscriptionUsersProfileRoute:
      AuthenticatedActiveSubscriptionUsersProfileRoute,
    AuthenticatedActiveSubscriptionUsersSettingsRoute:
      AuthenticatedActiveSubscriptionUsersSettingsRoute,
    AuthenticatedActiveSubscriptionUsersTermsAndConditionsRoute:
      AuthenticatedActiveSubscriptionUsersTermsAndConditionsRoute,
  }

const AuthenticatedActiveSubscriptionRouteWithChildren =
  AuthenticatedActiveSubscriptionRoute._addFileChildren(
    AuthenticatedActiveSubscriptionRouteChildren,
  )

interface AuthenticatedRouteChildren {
  AuthenticatedActiveSubscriptionRoute: typeof AuthenticatedActiveSubscriptionRouteWithChildren
  AuthenticatedUsersOnboardingFifthStepRoute: typeof AuthenticatedUsersOnboardingFifthStepRoute
  AuthenticatedUsersOnboardingFirstStepRoute: typeof AuthenticatedUsersOnboardingFirstStepRoute
  AuthenticatedUsersOnboardingFourthStepRoute: typeof AuthenticatedUsersOnboardingFourthStepRoute
  AuthenticatedUsersOnboardingResumeRoute: typeof AuthenticatedUsersOnboardingResumeRoute
  AuthenticatedUsersOnboardingSecondStepRoute: typeof AuthenticatedUsersOnboardingSecondStepRoute
  AuthenticatedUsersOnboardingSixthStepRoute: typeof AuthenticatedUsersOnboardingSixthStepRoute
  AuthenticatedUsersOnboardingThirdStepRoute: typeof AuthenticatedUsersOnboardingThirdStepRoute
  AuthenticatedUsersOnboardingIndexRoute: typeof AuthenticatedUsersOnboardingIndexRoute
}

const AuthenticatedRouteChildren: AuthenticatedRouteChildren = {
  AuthenticatedActiveSubscriptionRoute:
    AuthenticatedActiveSubscriptionRouteWithChildren,
  AuthenticatedUsersOnboardingFifthStepRoute:
    AuthenticatedUsersOnboardingFifthStepRoute,
  AuthenticatedUsersOnboardingFirstStepRoute:
    AuthenticatedUsersOnboardingFirstStepRoute,
  AuthenticatedUsersOnboardingFourthStepRoute:
    AuthenticatedUsersOnboardingFourthStepRoute,
  AuthenticatedUsersOnboardingResumeRoute:
    AuthenticatedUsersOnboardingResumeRoute,
  AuthenticatedUsersOnboardingSecondStepRoute:
    AuthenticatedUsersOnboardingSecondStepRoute,
  AuthenticatedUsersOnboardingSixthStepRoute:
    AuthenticatedUsersOnboardingSixthStepRoute,
  AuthenticatedUsersOnboardingThirdStepRoute:
    AuthenticatedUsersOnboardingThirdStepRoute,
  AuthenticatedUsersOnboardingIndexRoute:
    AuthenticatedUsersOnboardingIndexRoute,
}

const AuthenticatedRouteWithChildren = AuthenticatedRoute._addFileChildren(
  AuthenticatedRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AuthenticatedRoute: AuthenticatedRouteWithChildren,
  AuthLoginRoute: AuthLoginRoute,
  UsersEmailVerificationRoute: UsersEmailVerificationRoute,
  UsersPasswordResetRoute: UsersPasswordResetRoute,
  UsersRegistrationRoute: UsersRegistrationRoute,
  UsersSubscriptionFailureRoute: UsersSubscriptionFailureRoute,
  UsersSubscriptionPlansRoute: UsersSubscriptionPlansRoute,
  UsersSubscriptionSuccessRoute: UsersSubscriptionSuccessRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
